import { useState, useEffect } from 'react';
import api from '../services/api';

// // Custom hook for API calls with loading and error states
export const useAPI = (apiCall, dependencies = []) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // Memoize the API call to prevent unnecessary re-renders


  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);
        const result = await apiCall();
        setData(result);
      } catch (err) {
        setError(err);
        console.error('API Hook Error:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },dependencies);

  const refetch = async () => {
    try {
      setLoading(true);
      setError(null);
      const result = await apiCall();
      setData(result);
      return result;
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { data, loading, error, refetch };
};

// // Hook for services
export const useServices = () => {
  return useAPI(() => api.services.getAll());
};

// Hook for jobs with search parameters
export const useJobs = (searchParams = {}) => {
  return useAPI(() => api.jobs.getAll(searchParams), [
    searchParams.search,
    searchParams.industry,
    searchParams.job_type,
    searchParams.location,
    searchParams.page,
    searchParams.limit
  ]);
};
//Site Settings Hook
export const useSiteSettings = () => {
  return useAPI(() => api.siteSettings.getAll());
};

export const applyJob = (formData) => { 
  return api.jobs.applyNow(formData);
};
//

export const forEmployeers = (formData) => { 
  return api.jobs.hireNow(formData);
};
// Hook for testimonials
export const useTestimonials = () => {
  return useAPI(() => api.testimonials.getAll());
};

// Hook for single job
export const useJob = (jobId) => {
  return useAPI(() => api.jobs.getById(jobId), [jobId]);
};

// Hook for candidate applications
export const useCandidateApplications = (email) => {
  return useAPI(() => api.applications.getByCandidate(email), [email]);
};